import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchVendorPriceTable } from '../../actions/vendors_actions';
import { Button, Col, Row } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../Widgets/spinner';
import { Translate } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';
const DateFormatter = React.createClass({
  render() {
    if (this.props.value) {
      const date = new Date(this.props.value);
      return <span>{date.toString().slice(4, 15)}</span>;
    }
    return <span className="label label-danger">-</span>;
  },
});
class PriceTableModal extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      selectedRows: [],
      editedRows: [],
      filters: {},
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
      selectedDay: null,
      dayOptions: [],
    }
  }
  componentDidMount() {
    if (this.props.currentVendor) {
      this.props.fetchVendorPriceTable(this.props.currentVendor.Vendor_id);
    }
  }
  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.priceTable !== this.props.priceTable) {
      this.setState({ rows: nextProps.priceTable });
    }
  }

  handleGridSort = (sortColumn, sortDirection) => {
    let state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
    this.setState(state);
  }
  getRows = () => Data.Selectors.getRows(this.state);
  rowGetter = (rowIdx) => {
    const rows = this.getRows();
    return rows[rowIdx];
  };
  handleFilterChange = filter => {
    let newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({ filters: newFilters });
  }
  handleRowUpdated = e => {
    // merge updated row with current row and rerender by setting state
    let rows = this.state.rows.slice(0);
    let editedRows = this.state.editedRows.slice(0);
    Object.assign(rows[e.rowIdx], e.updated);
    // if the element is already edited, remove the old one.
    editedRows.forEach((element, index) => {
      if (element.Product_id === rows[e.rowIdx].Product_id)
        editedRows.splice(index, 1)
    }, this);
    // push the row into the editedRows array
    editedRows.push(rows[e.rowIdx]);
    this.setState({
      rows: rows,
      editedRows: editedRows
    });
  }
  onRowSelect = rows => {
    this.setState(...this.state, { selectedRows: rows });
  }
  getSize = () => {
    return this.getRows().length;
  }
  render() {
    if (this.props.isLoadingPriceTable) {
      return (
        <Spinner/>
      );
    }
    const handleCreate = () => {
      const { onOpenForm } = this.props;
      onOpenForm && onOpenForm();
    }
    const handleEdit = () => {
      const { onOpenForm } = this.props;
      onOpenForm && onOpenForm(this.state.selectedRows[0]);
    }
    const columns = [
      {
        key: 'Product_Name',
        name: <Translate value="product_name" />,
        resizable: true,
        filterable: true,
        width: 300,
      },
      {
        name: <Translate value="price_level" />,
        resizable: true,
        filterable: true,
        width: 320,
        getRowMetaData: row => row,
        formatter: ({dependentValues}) => {
          const priceLevels = dependentValues.quantity_price_list.map(item => `${item.quantity_price}(${item.min_quantity}${dependentValues.Package_Type}-${item.max_quantity}${dependentValues.Package_Type})`)
          return <span>{priceLevels.join(', ')}</span>
        }
      },
      {
        key: 'Quote_date',
        name: <Translate value="quote_date" />,
        filterable: true,
        resizable: true,
        width: 120,
        formatter: DateFormatter,
      },
      {
        key: 'Quote_Validity',
        name: <Translate value="quote_validity" />,
        filterable: true,
        resizable: true,
        width: 120,
        formatter: DateFormatter,
      },
      {
        key: 'Lead_time',
        name: <Translate value="lead_time" />,
        filterable: true,
        resizable: true,
        width: 80
      },
      {
        key: 'Creator_Name',
        name: <Translate value="creator" />,
        filterable: true,
        resizable: true,
        width: 165,
      },
    ];
    return (
      <Row>
        <Col sm={12} style={{position: 'absolute', zIndex: 1000, display: 'flex', flexDirection: 'row', gap: '10px'}}>
          <Button onClick={handleCreate}  disabled={!checkPermission("create_vendor_pt")}><i className="fa fa-plus" /> <Translate value="create" /></Button>
          <Button bsStyle="warning" onClick={handleEdit} disabled={this.state.selectedRows.length === 0 || !checkPermission("edit_vendor_pt")}><i className="fa fa-pencil" /> <Translate value="edit" /></Button>
        </Col>
        <Col sm={ 12 }>
          <div id="Vendors-dataGrid1">
            <ReactDataGrid
              rowKey='Product_id'
              enableCellSelect={true}
              onGridSort={this.handleGridSort}
              toolbar={<Toolbar enableFilter/>}
              onAddFilter={this.handleFilterChange}
              columns={columns}
              rowHeight={25}
              headerRowHeight={45}
              rowGetter={this.rowGetter}
              rowsCount={this.getSize()}
              minHeight={this.state.tableHeight}
              enableRowSelect='single'
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={this.onRowSelect}
            />
          </div>
        </Col>
      </Row>
    )
  }
}
const mapStateToProps = state => {
  return {
    priceTable: state.vendors.priceTable.all,
    currentVendor: state.vendors.currentVendor,
    priceTableData: state.vendors.priceTable.all,
    isLoadingPriceTable: state.vendors.priceTable.isLoading,
  }
}
const mapDispatchToProps = {
  fetchVendorPriceTable
}
export default connect(mapStateToProps, mapDispatchToProps)(PriceTableModal)



// WEBPACK FOOTER //
// ./master/jsx/components/Vendors/priceTableModal.jsx